import { useLocation, useParams } from 'react-router-dom';

export default function useEditingPath() {
    const location = useLocation();
    const { page } = useParams()
    const isEditing = /\/edit\/?$/.test(location.pathname);
    const currentPath = page || "home";

    return { isEdit: isEditing, path: currentPath };
}